export default "__VITE_ASSET__DInnXhbX__"